import { forwardRef } from 'react';

import DateTimeInputInline from 'components/Inputs/inline/DateTimeInput';

import { withCellWrapper } from '../helpers';

const _LastModifiedCell = forwardRef(
  (
    { value, field, objectId, entityId, adornments = [], shouldFocusNext },
    ref
  ) => {
    return (
      <DateTimeInputInline
        ref={ref}
        field={field}
        entityId={entityId}
        objectId={objectId}
        readOnly
        value={value}
        showDateTooltip
        shouldFocusNext={shouldFocusNext}
        adornments={adornments}
      />
    );
  }
);

export const LastModifiedCell = withCellWrapper(_LastModifiedCell);
